import { render, staticRenderFns } from "./PlaceTab.vue?vue&type=template&id=0e12f280&scoped=true"
import script from "./PlaceTab.vue?vue&type=script&lang=ts"
export * from "./PlaceTab.vue?vue&type=script&lang=ts"
import style0 from "./PlaceTab.vue?vue&type=style&index=0&id=0e12f280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e12f280",
  null
  
)

export default component.exports